import { Type } from "class-transformer";
import { AuthSecondFactor } from "./AuthSecondFactor";
import { PasswordRules } from "./PasswordRules";
import { UserNameNormalization } from "./UserNameNormalization";

export class AuthRules {
    userNameIsEmail = false;
    loginUserNameHint: string;
    userNameNormalization: UserNameNormalization = UserNameNormalization.upperCase;
    anonymousOnly = false;
    canRegister = false;
    canRevokePassword = false;
    canRevokePasswordSelf = false;
    revokePasswordPerEmailIfSet = true;
    canChangePassword = false;
    revokePasswordMessage: string;
    revokePasswordAfterMessage: string;
    useRecoveryQuestions = false;
    minRecoveryQuestions = 3;
    correctRecoveryQuestions = 3;
    @Type(() => PasswordRules)
    passwordRules: PasswordRules = new PasswordRules();
    authQuestions: string[];
    secondFactor: AuthSecondFactor = AuthSecondFactor.none;
}
